module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"card_title":"Weitere Funktionen","open_excel_dialog_btn":"Excel-Dialog öffnen","output_data_excel_file_btn":"Excel-Export aktiven Exklusiv"},"en":{"card_title":"Additional functions","open_excel_dialog_btn":"Excel-Export active Exklusiv","output_data_excel_file_btn":""}}')
  delete Component.options._Ctor
}
